import React, { useId } from 'react';

import { cn, Label, SuggestAutocomplete } from '@src/components/ui';


/**
 * Base suggest field — label above, free-text-with-suggestions combobox, helper/
 * error line below. Same chrome as SelectField / AutocompleteField but renders
 * `SuggestAutocomplete`, where the value IS the typed string and `options` are
 * non-binding suggestions. Receives RHF field props (value/onChange/onBlur/name/
 * ref) plus `error` (bool) and `helperText` from the generic wrapper. Only the
 * props SuggestAutocomplete reads are forwarded; RHF's `onBlur`/`name` are
 * intentionally not passed.
 */
const SuggestField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    onChange,
    error = false,
    helperText = ' ',
    className,
    options = [],
    placeholder,
    loading = false,
    disabled = false,
    emptyText,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label
        ? (
          <Label htmlFor={id}>{label}</Label>
        )
        : null}

      <SuggestAutocomplete
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        disabled={disabled}
        emptyText={emptyText}
        options={options}
        loading={loading}
        onChange={onChange}
        placeholder={placeholder}
      />

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
});

SuggestField.displayName = 'SuggestField';
export default SuggestField;
